import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["layoutType", "value", "label", "description", "image"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Typography } from '@snack-uikit/typography';
import styles from "./styles.module.css";
import { getLabelTypographyProps, getValueTypographyProps } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CardLeading(_ref) {
  var layoutType = _ref.layoutType,
    value = _ref.value,
    label = _ref.label,
    description = _ref.description,
    image = _ref.image,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: styles.cardLeading
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.wrapper,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [/*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
          family: "sans"
        }, getValueTypographyProps(layoutType)), {}, {
          className: styles.cardLeadingColor,
          children: value
        })), /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
          family: "sans"
        }, getLabelTypographyProps(layoutType)), {}, {
          className: styles.cardLeadingColor,
          children: label
        }))]
      }), /*#__PURE__*/_jsx("img", {
        className: styles.illustration,
        src: image,
        alt: "illustration"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.footer,
        "data-layout-type": layoutType,
        children: /*#__PURE__*/_jsx(Typography.SansBodyL, {
          className: styles.cardLeadingColor,
          children: description
        })
      })]
    })
  }));
}